module.exports = __webpack_public_path__ + "img/5.5b6d8f19.png";